module.exports = __webpack_public_path__ + "img/compliance2.cb7b203e.svg";